import { create } from "zustand";
import { persist } from "zustand/middleware";
function newId(prefix) {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
}
const useActivityStore = create()(
  persist(
    (set) => ({
      fieldAudits: [],
      timelineEvents: [],
      generatedInvoiceIds: [],
      recordFieldChange: (entry) =>
        set((s) => ({
          fieldAudits: [
            {
              ...entry,
              id: newId("aud"),
              at: new Date().toISOString(),
            },
            ...s.fieldAudits,
          ],
        })),
      appendTimeline: (event) =>
        set((s) => ({
          timelineEvents: [
            {
              ...event,
              id: newId("tl"),
              at: event.at ?? new Date().toISOString(),
            },
            ...s.timelineEvents,
          ],
        })),
      markInvoiceGenerated: (invoiceId) =>
        set((s) => ({
          generatedInvoiceIds: s.generatedInvoiceIds.includes(invoiceId)
            ? s.generatedInvoiceIds
            : [...s.generatedInvoiceIds, invoiceId],
        })),
    }),
    { name: "gps-erp-next-activity" },
  ),
);
function currentActorLabel() {
  try {
    const raw = localStorage.getItem("gps-erp-next-session");
    if (raw) {
      const parsed = JSON.parse(raw);
      const name = parsed.state?.user?.name;
      if (name) return name;
    }
  } catch {}
  return "Mock user";
}
export { currentActorLabel, useActivityStore };
